/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export function elementResize(element, callbackFn, async = true) {
    const observer = new ResizeObserver(() => {
        // We wrap the callback in requestAnimationFrame to
        // avoid the error of "ResizeObserver loop limit exceeded".
        if (async) {
            window.requestAnimationFrame(() => callbackFn());
        }
        else {
            callbackFn();
        }
    });
    observer.observe(element);
    observer.__testTrigger = callbackFn; // hook to trigger resize event as ResizeObserver does not run in headless chrome.
    return observer;
}
export function elementVisible(element, callbackFn) {
    const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting === true) {
            callbackFn();
        }
    }, { threshold: [0] });
    observer.observe(element);
    return observer;
}
/**
 * Given a ResponsiveComponent this function will loop through a list of layout
 * options and change the layout of the component until the components layout
 * condition is satisfied.
 */
export function calculateOptimalLayout(component, layoutConfig) {
    return component.updateComplete.then(() => {
        const currentLayout = component.layout;
        component.layout = layoutConfig.layouts[0];
        return layoutConfig.layouts
            .reduce((prev, next) => {
            return prev.then(() => {
                if (component.layout === layoutConfig.initialLayout) {
                    return next;
                }
                else {
                    const prev = component.layout;
                    component.layout = next;
                    return component.updateComplete.then(() => {
                        component.layout = component.layoutStable ? component.layout : prev;
                        return next;
                    });
                }
            });
        }, Promise.resolve(layoutConfig.layouts[0]))
            .then(() => currentLayout !== component.layout);
    });
}
